import {TextToolTip} from "components";
import {DeleteActionBtn, EditActionBtn} from "components";
import {allStatusesList, RateTypes, RateTypesList, Statuses} from "fragments";
import {Svg} from "assets";
import {renderPayerName} from "utils";

export const payerDetails = (item) => {
    return [
        {
            list: [
                {
                    title: "General Info",
                    list: [
                        {
                            title: "Display Name",
                            desc: item?.displayName || item?.name,
                        },

                        {
                            title: "Sync Name",
                            desc: item?.name,
                        },

                        {
                            title: "Phone Number",
                            desc: item?.phone,
                            phoneRow: true,
                        },
                    ],
                },

                {
                    title: "Address",
                    list: [
                        {
                            title: "Street",
                            desc: item?.address?.street,
                        },

                        {
                            title: "Unit/Suit #",
                            desc: item?.address?.unitNumber,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "City",
                            desc: item?.address?.city,
                        },

                        {
                            title: "State",
                            desc: item?.address?.state,
                        },
                    ],
                },

                {
                    list: [
                        {
                            title: "Country",
                            desc: item?.address?.country,
                        },

                        {
                            title: "Zip Code",
                            desc: item?.address?.zip,
                        },
                    ],
                },
            ],
        },
    ];
};

export const payersHead = () => {
    return [
        {title: "Display Name", name: 'displayName', searchKey: 'displayName', sortType: "displayName"},
        {title: "Sync Name", name: 'name', searchKey: 'name', sortType: "name"},
        {title: "Phone Number", name: 'phone', searchKey: 'phone', custom: false},
        {title: "Address", name: 'address', searchKey: 'address.formattedAddress', custom: false},
        {
            title: "Status",
            name: 'status',
            disabled: true,
            filterList: [{name: "All", id: "All"}, ...allStatusesList],
            width: 110
        },
        {title: "Action", custom: false, width: "116px"},
    ];
};

export const payersBody = ({handleDelete, handleEit}) => {
    return [
        {
            rowText: (item) => (
                <TextToolTip text={renderPayerName(item)} content={renderPayerName(item)}/>
            ),
        },

        {
            rowText: (item) => <TextToolTip text={item?.name} content={item?.name}/>,
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.phone} content={item?.phone} phoneRow/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.address?.formattedAddress}
                    content={item?.address?.formattedAddress}
                />
            ),
        },

        {
            rowText: (item) => <Statuses status={item?.status}/>,
        },

        {
            rowText: (item) => (
                <div className="flex-all-center" style={{gap: 8}}>
                    <DeleteActionBtn onClick={() => handleDelete(item)}/>
                    <EditActionBtn onClick={() => handleEit(item)}/>
                </div>
            ),
            notClickable: true,
        },
    ];
};

export const payerRatesHeader = () => {
    return [
        {
            title: "Type",
            name: "types",
            filterList: RateTypesList,
            multiple: true,
            sortType: "type",
        },
        {title: "Call Rate", sortType: "callRate", custom: false},
        {title: "Per Mile Rate", sortType: "perMileRate", custom: false},
        {title: "Night Call Rate", custom: false},
        {title: "No Show Rate", custom: false},
        {title: "Effective Date", custom: false},
        {title: "End Date", custom: false},
        {title: "Action", custom: false, width: "116px"},
    ];
};

export const payerRatesBody = ({handleDelete, handleEit}) => {
    return [
        {
            rowText: (item) => (
                <TextToolTip
                    text={RateTypes[item?.type]}
                    content={RateTypes[item?.type]}
                />
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.callRate} content={item?.callRate} priceRow/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.mileRate} content={item?.mileRate} priceRow/>
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.nightCallRate}
                    content={item?.nightCallRate}
                    priceRow
                />
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.cancelRate}
                    content={item?.cancelRate}
                    priceRow
                />
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.effectiveDate}
                    content={item?.effectiveDate}
                    dateRow
                />
            ),
        },

        {
            rowText: (item) => (
                <TextToolTip text={item?.endDate} content={item?.endDate} dateRow/>
            ),
        },

        {
            rowText: (item) => (
                <div className="flex-all-center" style={{gap: 8}}>
                    <EditActionBtn onClick={() => handleEit(item)}/>
                    <DeleteActionBtn onClick={() => handleDelete(item)}/>
                </div>
            ),
            notClickable: true,
        },
    ];
};

export const emptyState = (addPayer) => {
    return {
        emptyBtnText: 'Add Payer',
        notTitleText: 'No payers available',
        notDescText: 'Add a payer to start assigning them to trips or patients and managing them.',
        EmptySvg: Svg.EmptyPayer,
        clickToEmptyAddButton: () => addPayer(),
    }
}


export const emptyStateRates = () => {
    return {
        notTitleText: 'No Rates yet',
        notDescText: 'Click to Add Rate',
        EmptySvg: Svg.EmptyVehicle,
    }
}
